import { useStorageState } from "../../../lib/storage";
import IconButton from "../IconButton/IconButton";
import styles from "./hintBox.css";

export const HintKey = {
  libraryExternalContents: "library:externalContents",
};

/**
 * HintBox is a React functional component that displays a box with a header and text.
 * It includes a close button to hide the box, and remembers the hidden state for
 * the rest of the session.
 *
 * All hint boxes share one flag, so closing any one of them hides every hint box
 * currently on screen — not just the next ones to mount.
 *
 * @param {Object} props - The input properties for the component.
 * @param {string} props.header - The header text to display in the hint box.
 *
 * @returns {JSX.Element} The rendered hint box component.
 */
const HintBox = ({ header, children, hintKey }) => {
  const [displayNone, setDisplayNone] = useStorageState(hintKey, false, {
    type: "session",
  });

  function handleClick() {
    setDisplayNone(true);
  }

  return (
    <div className={styles.container({ hidden: displayNone })}>
      <div className={styles.topDiv}>
        <h2 className={styles.header}>{header}</h2>
        <IconButton name="xmark" onClick={handleClick} />
      </div>
      <p>{children}</p>
    </div>
  );
};

export default HintBox;
